import { useParams } from 'react-router-dom';

import { AppIapPollsPage } from '~/components/pages/AppIapPollsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppIapPollsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppIapPollsPage appId={appId} />
    </DashboardTemplate>
  );
};
